import { Component, AfterViewInit, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MdDialog } from '@angular/material';

import { Constante } from '../../../../models';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import {
  TdLoadingService, TdMediaService, TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
} from '@covalent/core';

@Component({
  selector: 'qs-detalleconstantes',
  templateUrl: './detalleconstantes.component.html',
})

export class ConstantesDetalleComponent implements AfterViewInit {

  private _toggleConstantes: boolean = true;

  @ViewChild( BaseChartDirective ) chart: BaseChartDirective;
  public constante: Constante;
  public datos: any;
  public graph: any;
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';
  public lineChartLabels: any[][] = [];
  public lineChartData: any = [{
      data: [],
      label: 'Texto del label',
      lang: 'es',
      title: 'titulo',
    }];
  public lineChartColors: any[] = [
    {
      backgroundColor: 'rgba(0,0,0,0.2)',
      borderColor: 'rgba(25,118,201,0.8)',
      pointBackgroundColor: [],
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: [],
      pointHoverBorderColor: 'rgba(148,159,177,0.8)',
    },
  ];
  public lineChartOptions: any = {
    responsive: true,
  };

  constructor(private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    private _loadingService: TdLoadingService) {
    }

  OnInit(): void {
    this.lineChartLabels = [];
    this._changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._loadingService.register('detalleconstantes.load');

    let labels: string[] = [];
    const _lineChartData: any[] = new Array(this.constante.tomas.length);
    let _lineChartColors: any[] = new Array(this.constante.tomas.length);

    _lineChartData[0] = {data: new Array(this.constante.tomas.length), label: this.constante.descripcion};
    _lineChartColors[0] = {pointBackgroundColor: new Array(this.constante.tomas.length)};

    for (let i: number = 0; i < this.constante.tomas.length; i++) {
      _lineChartData[0].data[i] = this.constante.tomas[i].valor;
      this.lineChartColors[0].pointBackgroundColor[i] = this.constante.tomas[i].color === 'ff0000' ? 'rgb(189,48,3,1)' : 'rgb(57,162,5,1)';
      this.lineChartColors[0].pointHoverBackgroundColor[i] = this.lineChartColors[0].pointBackgroundColor[i];
      if (!Number.isNaN(_lineChartData[0].data[i])) {
        _lineChartData[0].data[i] = parseFloat(_lineChartData[0].data[i].toString().replace(/,/g, '.'));
      }
      labels.push(String(this.constante.tomas[i].fecha));
    }

    this.lineChartData = _lineChartData;
    this.chart.labels = labels;
    this.chart.ngOnChanges({});

    this._loadingService.resolve('detalleconstantes.load');
    this._changeDetectorRef.detectChanges();
  }

  close(): void {
    this._dialogService.closeAll();
  }
  toggleConstantes(): void {
    this._toggleConstantes = !this._toggleConstantes;
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/constantes/detalleconstantes/detalleconstantes.component.ts